var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('vue-plyr',{attrs:{"options":_vm.player_settings}},[_c('div',{staticStyle:{"--plyr-color-main":"#36B34A"},attrs:{"data-plyr-provider":"youtube","data-plyr-embed-id":_vm.url}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }